const overviewTimeseriesMockData = async ({ aggregationPeriod }) => {
    const setRequestUrl = () => {
        if (aggregationPeriod === "day")
            return `https://assets-sit.adadot.com/mock-data/executive-summary/overview-timeseries-mock-data.js`;
        if (aggregationPeriod === "week")
            return `https://assets-sit.adadot.com/mock-data/executive-summary/overview-timeseries-mock-data-week.js`;
        if (aggregationPeriod === "month")
            return `https://assets-sit.adadot.com/mock-data/executive-summary/overview-timeseries-mock-data-month.js`;
        return `https://assets-sit.adadot.com/mock-data/executive-summary/overview-timeseries-mock-data.js`;
    };
    const requestUrl = setRequestUrl();

    try {
        const module = await import(
            /* webpackIgnore: true */
            `${requestUrl}`
        );
        return module.default;
    } catch (error) {
        return null;
    }
};
export default overviewTimeseriesMockData;
